import trimStart from "lodash/trimStart";
export const ckEditorDirective = (
  $timeout,
  $q,
  NgCkEditorService,
  AuthService,
  API_ENDPOINT
) => {
  "ngInject";

  const userDetails = AuthService.getUser();
  const token = userDetails.token;
  const fileUploadUrl = `${API_ENDPOINT}/file/ckeditor-upload?token=${token}`;

  return {
    restrict: "AC",
    require: ["ngModel", "^?form"],
    scope: {
      plainText: "=?plainText",
    },
    link: function (scope, element, attrs, ctrls) {
      var ngModel = ctrls[0];
      var form = ctrls[1] || null;
      var EMPTY_HTML = "<p></p>",
        isTextarea = element[0].tagName.toLowerCase() === "textarea",
        data = [],
        isReady = false;
      if (!isTextarea) {
        element.attr("contenteditable", true);
      }
      var loaded = false;
      var font = "font-family:'Roboto'; ";
      var rules = {
        elements: {
          li: function (el) {
            if (!el.attributes.style) {
              if (el.parent.name === "ol") {
                el.attributes.style = font + "color:var(--primary-#ccc);";
              } else if (el.parent.name === "ul") {
                el.attributes.style = font + "color:#000;";
              }
            }
          },
          p: function (el) {
            if (!el.attributes.style) {
              el.attributes.style =
                font +
                "color: #000; font-size :1rem; word-wrap: break-word; line-height: 1.4;";
            }
          },
          h1: function (el) {
            if (!el.attributes.style) {
              el.attributes.style = font + "color: var(--primary-#ccc);";
            }
          },
          h2: function (el) {
            if (!el.attributes.style) {
              el.attributes.style = font + "color: var(--primary-#ccc);";
            }
          },
          a: function (el) {
            if (!el.attributes.style) {
              el.attributes.style = font + "color: #0782C1;";
            }
          },
          span: function (el) {
            if (!el.attributes.style) {
              el.attributes.style = font + "color: var(--primary-#ccc);";
            }
          },
        },
      };
      var onLoad = function () {
        var options = {
          toolbar: "custom",
          toolbar_full: [
            //jshint ignore:line
            {
              name: "basicstyles",
              items: ["Bold", "Italic", "Strike", "Underline"],
            },
            {
              name: "paragraph",
              items: ["BulletedList", "NumberedList", "Blockquote"],
            },
            {
              name: "editing",
              items: [
                "JustifyLeft",
                "JustifyCenter",
                "JustifyRight",
                "JustifyBlock",
              ],
            },
            {
              name: "links",
              items: ["Link", "Unlink", "Anchor"],
            },
            {
              name: "tools",
              items: ["SpellChecker", "Maximize"],
            },
            "/",
            {
              name: "styles",
              items: [
                "Format",
                "FontSize",
                "TextColor",
                "PasteText",
                "PasteFromWord",
                "RemoveFormat",
              ],
            },
            {
              name: "insert",
              items: ["Image", "Table", "SpecialChar"],
            },
            {
              name: "forms",
              items: ["Outdent", "Indent"],
            },
            {
              name: "clipboard",
              items: ["Undo", "Redo"],
            },
            {
              name: "document",
              items: ["PageBreak", "Source"],
            },
          ],
          toolbar_custom: [
            {
              name: "basicstyles",
              items: ["Bold", "Italic", "-", "RemoveFormat", "FontSize"],
            },
            {
              name: "clipboard",
              items: ["Cut", "Copy", "Paste"],
            },
            {
              name: "editing",
              items: [
                "JustifyLeft",
                "JustifyCenter",
                "JustifyRight",
                "JustifyBlock",
              ],
            },
            {
              name: "links",
              items: ["Link", "Unlink" /*'Anchor'*/],
            },
            {
              name: "insert",
              items: ["Table", "HorizontalRule", "Image"],
            },
            {
              name: "styles",
              items: ["Format"],
            },
            {
              name: "paragraph",
              items: [
                "NumberedList",
                "BulletedList",
                "-",
                "Outdent",
                "Indent",
                "Blockquote",
              ],
            },
          ],
          disableNativeSpellChecker: false,
          uiColor: "#f5f5f5",
          height: "400px",
          width: "100%",
          stylesSet: "myStyle",
          // font_defaultLabel: "Roboto",
          // font_names: "Roboto",
          on: {
            instanceReady: function () {
              this.dataProcessor.dataFilter.addRules({
                attributes: {
                  style: function (e) {
                    console.log(e);
                  },
                },
              });
              this.dataProcessor.htmlFilter.addRules(rules);
            },
          },
          filebrowserImageUploadUrl: fileUploadUrl,
        };
        options = angular.extend(options, scope.$eval(attrs.ckeditor));
        var instance = isTextarea
            ? CKEDITOR.replace(element[0], options)
            : CKEDITOR.inline(element[0], options),
          configLoaderDef = $q.defer();
        element.bind("$destroy", function () {
          if (instance && CKEDITOR.instances[instance.name]) {
            CKEDITOR.instances[instance.name].destroy();
          }
        });
        var setModelData = function (setPristine) {
            var data = instance.getData();
            if (data === "") {
              data = null;
            }
            data = `<!DOCTYPE HTML>
                            <html>
                            <head>
                            <meta charset="UTF-8"> 
                            <meta name="viewport" content="width=device-width, initial-scale=1.0">
							<style>
                            body {
                            margin: 0;
                            padding: 0;
                            color: #292929;
                            font-size: 1rem;
                            }
                            p {
                            margin: 0;
                            padding: 0;
                            }
                            </style>
                            </head>
                            <body>
                            ${data}
                            </body>
                            
                            </html>`;
            $timeout(function () {
              // for key up event
              if (setPristine !== true || data !== ngModel.$viewValue) {
                ngModel.$setViewValue(data);
              }
              if (setPristine === true && form) {
                form.$setPristine();
              }
              // console.log("efw", instance.document.$.body.innerText)
              scope.plainText = trimStart(instance.document.$.body.innerText);
            }, 0);
          },
          onUpdateModelData = function (setPristine) {
            if (!data.length) {
              return;
            }

            var item = data.pop() || EMPTY_HTML;
            isReady = false;
            instance.setData(item, function () {
              setModelData(setPristine);
              isReady = true;
            });
          };

        instance.on("pasteState", setModelData);
        instance.on("change", setModelData);
        instance.on("blur", setModelData);
        //instance.on('key',          setModelData); // for source view

        instance.on("instanceReady", function () {
          scope.$broadcast("ckeditor.ready");
          scope.$apply(function () {
            onUpdateModelData(true);
          });

          instance.document.on("keyup", setModelData);
        });
        instance.on("customConfigLoaded", function () {
          configLoaderDef.resolve();
        });

        ngModel.$render = function () {
          data.push(ngModel.$viewValue);
          if (isReady) {
            onUpdateModelData();
          }
        };
      };

      if (CKEDITOR.status === "loaded") {
        loaded = true;
      }
      if (loaded) {
        onLoad();
      } else {
        NgCkEditorService.getLoaded.then(onLoad);
      }
    },
  };
};



// WEBPACK FOOTER //
// ./src/app/common/libs/ng-ckeditor/ng-ckeditor.directive.js